export default {
  "Login for users": "Вход в аккаунт",
  Login: "Электронная почта/ телефон",
  Password: "Пароль",
  Submit: "Войти",
  "Field required": "Поле обязательно",
  "Auth error 400": "Неверный логин или пароль",
  "Auth error network":
    "Проблема с подключением. Проверьте ваше интернет-соединение и попробуйте снова.",
  "Auth error unknown": "Ошибка. Повторите вашу попытку позже.",
  "Login title": "Авторизация | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Not account yet": "Нет аккаунта?",
  "Not account yet about":
    "Вы можете создать аккаунт или войти в демо-режим с ограниченным функционалом",
  "Demo-mode": "Демо-режим",
  "Let register": "Регистрация",
  "User Agreement Title":
    "Пользовательское соглашение | " + process.env.VUE_APP_INSTALL_NAME + "",
  "User Agreement": "Пользовательское соглашение",
  "Privacy policy": "Политика обработки персональных данных",
  "User Agreement About part 1":
    "Продолжая использование сайта, вы принимаете условия ",
  "User Agreement About part 2": "пользовательского соглашения.",
  "User Agree": "Принимаю",
  "Page not found": "Страница не найдена",
  "Page not found about":
    "Неправильно набран адрес или такой страницы больше не существует. Вернитесь на главную страницу",
  "Back to main page": "Вернуться на главную",
  "Login for users 2":
    "Получите полный доступ к функционалу платформы " +
    process.env.VUE_APP_INSTALL_NAME +
    "",
  Step: "Шаг",
  "Min 8": "Не менее 8 символов",
  "1 char": "1 буква",
  "1 num": "1 цифра",
  "Auth access 1": "Согласен на ",
  "Auth access 2": "обработку персональных данных",
  "Auth access 3": ", принимаю условия ",
  "Auth access 4": "политики",
  "Auth access 5": "и",
  "Auth access 6": "пользовательского соглашения",
  "Auth access 7": "получение рассылки рекламно-информационных материалов",
  "Have account?": "Есть аккаунт?",
  "To next": "Далее",
  "Reg for users 1": "Создайте аккаунт",
  "Reg for users 2": "Расскажите о себе",
  "Reg for users 3": "Завершение регистрации",
  "Your last_name": "Ваша фамилия",
  "Your first_name": "Ваше имя",
  "Your middle_name": "Ваше отчество",
  "Your company": "Место работы",
  "Your position_in_the_company": "Ваша специальность",
  Back: "Назад",
  "Min 2": "Не менее 2х символов",
  Promo: "Промокод (если есть)",
  invitation_1: "От знакомых / коллег",
  invitation_2: "Email-рассылка",
  invitation_3: "Поиск в Яндекс, Google",
  invitation_4: "Другой источник",
  invitation_5: "Социальные сети",
  "Where know about platform?": "Откуда вы узнали о Платформе?",
  "Reg finish": "Зарегистироваться",
  regErrorText: "Не удалось зарегистрировать пользователя. Проверьте данные",
  "Auth banner text":
    "Авторизуйтесь, чтобы получить полный доступ к функционалу Платформы",
  "Auth banner text 2":
    "Авторизуйтесь, чтобы увеличить количество исследований для обработки",
  "Auth banner text 3":
    "Получите бесплатную обработку 10<br/>ваших исследований",
  "Reg error":
    "К сожалению, не удалось завершить регистрацию из-за технической ошибки. Пожалуйста, повторите попытку позже",
  "Reg error 400": "Адрес электронной почты уже используется",
  "Rem password": "Введите электронную почту, указанную при регистрации",
  Phone: "Телефон",
  "Not valid phone": "Неверный формат номера телефона",
  emailVerify: {
    title: "Подтверждение эл. почты",
    desc1: "На почту ",
    desc2:
      " отправлено письмо с подтверждением. Пожалуйста, перейдите по ссылке в письме, чтобы активировать ваш аккаунт и получить доступ к сервису.",
  },
};
